<template>
  <b-card-body>
    <h5>{{ $t('question') }}</h5>
    <div v-if="isDefaultLanguage" style="width: 100%;">
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input v-model="question.value1"  class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder=":"></b-form-input>
            <b-form-input v-model="question.value2" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder="="></b-form-input>
            <b-form-input v-model="question.value3" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder=":"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <div v-if="!isDefaultLanguage" style="width: 100%;">
      <b-row style="margin-bottom: 5px;">
        <b-col>
          <b-input-group>
            <b-form-input readonly disabled v-model="question.defaultValue1" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder=":"></b-form-input>
            <b-form-input readonly disabled v-model="question.defaultValue2" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder="="></b-form-input>
            <b-form-input readonly disabled v-model="question.defaultValue3" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder=":"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input v-model="question.value1" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder=":"></b-form-input>
            <b-form-input v-model="question.value2" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder="="></b-form-input>
            <b-form-input v-model="question.value3" class="input"></b-form-input>
            <b-form-input readonly disabled class="input" style="font-weight: bold;" placeholder=":"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <h5 style="margin-top: 25px;">{{ $t('questionalternative') }}</h5>
    <div v-if="isDefaultLanguage">
      <b-input-group v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternative.id" class="alternatives">

        <b-form-input type="text" v-model="alternative.text" />
        <b-input-group-append is-text>
          <input :id="`alternative-${alternative.text}`" class="me-2" type="checkbox" :checked="alternative.points > 0" :value="1" @change="e => onSelectAlternative(e, alternative)" />
          <label :for="`alternative-${alternative.text}`">
            {{ $t('privatePage.scaleQuestionsCorrectAnswer') }}
          </label>
        </b-input-group-append>
        <b-input-group-append>
          <b-button v-if="isDefaultLanguage"
                variant="danger"
                @click.stop="deleteObjectFromCollection(question.alternatives, alternativeIndex)">
                x
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <div v-if="!isDefaultLanguage">
      <b-input-group v-for="(alternative) in question.alternatives" :key="alternative.id" class="alternatives">
        <b-form-input type="text" v-model="alternative.text" />
        <b-form-input readonly disabled type="text" v-model="alternative.defaultText" />
      </b-input-group>
    </div>

    <b-button ref="addAlternativeButton"
              class="me-2"
              style="margin-top: 5px;"
              v-if="isDefaultLanguage"
              @click.stop="addAlternative(question.alternatives)">
              {{ $t('privatePage.scaleQuestionsAlternativeAdd') }}
    </b-button>

    <b-button ref="deleteQuestionButton"
      variant="danger"
      style="margin-top: 5px;"
      v-if="isDefaultLanguage && isPartOfCollection"
      @click.stop="$emit('onDeleteQuestion', questionIndex)">
      {{ $t('privatePage.scaleQuestionsDelete') }}
    </b-button>
  </b-card-body>
</template>

<script>
import editorFuncs from '../questioneditorfuncs'

export default {
  name: 'gverb-module',
  props: {
    question: {},
    questionIndex: 0,
    isDefaultLanguage: false,
    isPartOfCollection: false
  },
  methods: {
    deleteObjectFromCollection(collection, index) {
      editorFuncs.deleteObjectFromCollection(collection, index)
    },
    addAlternative() {
      editorFuncs.addAlternative(
        this.question.alternatives
      )
    },
    onSelectAlternative(event, selected) {
      const value = event.target.value
      const checked = event.target.checked
      if (checked) {
        selected.points = value
      } else {
        selected.points = 0
      }
    }
  },
  created() {
    if (this.question.alternatives.length === 0) {
      this.addAlternative()
    }
  }
}
</script>

<style scoped>
.alternatives {
  margin-bottom: 5px;
}

.input {
  text-align: center;
}
</style>
